(function () {
  'use strict';

  var COLLECTION_TAP_THRESHOLD = 12;

  function isCollectionInteractiveTarget(target) {
    return !!(
      target &&
      target.closest(
        '[data-product-card-prev], [data-product-card-next], [data-product-card-cart], .rabitat-product-card__cart-btn, button, a[href]'
      )
    );
  }

  function bindCollectionCardNavigation(card) {
    if (!card.closest('[data-collection-carousel]')) return;
    if (card.dataset.collectionNavBound === 'true') return;
    card.dataset.collectionNavBound = 'true';

    var coverLink = card.querySelector('[data-product-card-link]');
    if (!coverLink) return;

    var startX = 0;
    var startY = 0;
    var touchMoved = false;
    var touchActive = false;

    card.addEventListener(
      'touchstart',
      function (event) {
        if (!window.matchMedia('(max-width: 768px)').matches) return;
        if (!event.touches || !event.touches.length) return;
        if (isCollectionInteractiveTarget(event.target)) return;

        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        touchMoved = false;
        touchActive = true;
      },
      { passive: true }
    );

    card.addEventListener(
      'touchmove',
      function (event) {
        if (!touchActive || !event.touches || !event.touches.length) return;

        var deltaX = event.touches[0].clientX - startX;
        var deltaY = event.touches[0].clientY - startY;

        if (Math.abs(deltaX) > COLLECTION_TAP_THRESHOLD || Math.abs(deltaY) > COLLECTION_TAP_THRESHOLD) {
          touchMoved = true;
        }
      },
      { passive: true }
    );

    card.addEventListener(
      'touchend',
      function () {
        touchActive = false;
      },
      { passive: true }
    );

    card.addEventListener(
      'touchcancel',
      function () {
        touchActive = false;
        touchMoved = true;
      },
      { passive: true }
    );

    card.addEventListener(
      'click',
      function (event) {
        if (!window.matchMedia('(max-width: 768px)').matches) return;
        if (touchMoved) {
          touchMoved = false;
          return;
        }
        if (isCollectionInteractiveTarget(event.target)) return;
        if (!coverLink.href) return;

        event.preventDefault();
        window.location.assign(coverLink.href);
      },
      true
    );
  }

  function initProductCards() {
    document.querySelectorAll('[data-product-card]:not([data-product-card-initialized])').forEach(function (card) {
      card.setAttribute('data-product-card-initialized', '');
      var jsonEl = card.querySelector('[data-product-card-variants]');
      if (!jsonEl) return;

      var variants;
      try {
        variants = JSON.parse(jsonEl.textContent);
      } catch (error) {
        return;
      }

      if (!variants.length) return;

      var prevBtn = card.querySelector('[data-product-card-prev]');
      var nextBtn = card.querySelector('[data-product-card-next]');
      if (variants.length <= 1) {
        if (prevBtn) prevBtn.hidden = true;
        if (nextBtn) nextBtn.hidden = true;
      }

      var current = 0;
      var initialVariantId = card.getAttribute('data-initial-variant-id');
      if (initialVariantId) {
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === String(initialVariantId)) {
            current = i;
            break;
          }
        }
      }
      var image = card.querySelector('[data-product-card-image], .rabitat-product-card__image:not(.rabitat-product-card__image--placeholder)');
      var variantName = card.querySelector('[data-product-card-variant-name]');
      var priceEl = card.querySelector('[data-product-card-price]');
      var compareEl = card.querySelector('[data-product-card-compare]');
      var offBadge = card.querySelector('[data-product-card-off]');
      var cartLink = card.querySelector('[data-product-card-cart]');
      var coverLink = card.querySelector('[data-product-card-link]');
      var cartLabel = cartLink ? cartLink.getAttribute('data-product-card-cart-label') || 'Add to Cart' : 'Add to Cart';
      var soldOutLabel = cartLink ? cartLink.getAttribute('data-product-card-sold-out-label') || 'Sold out' : 'Sold out';
      var signupLabel = cartLink ? cartLink.getAttribute('data-product-card-signup-label') || 'Sign up' : 'Sign up';
      var isSignupCard = card.hasAttribute('data-product-card-signup');

      var render = function (index) {
        var variant = variants[index];
        if (!variant) return;

        if (image && variant.image) {
          if (window.RabitatResponsiveImage) {
            window.RabitatResponsiveImage.apply(image, variant.image, {
              preset: 'card',
              loading: 'lazy',
            });
          } else {
            image.src = variant.image;
            image.removeAttribute('srcset');
          }
        }

        if (variantName) {
          variantName.textContent = variant.name;
        }

        if (priceEl) {
          priceEl.innerHTML = variant.price_formatted;
        }

        if (compareEl) {
          if (variant.compare_at_price > variant.price) {
            compareEl.innerHTML = variant.compare_formatted;
            compareEl.classList.remove('rabitat-product-card__compare--hidden');
          } else {
            compareEl.innerHTML = '';
            compareEl.classList.add('rabitat-product-card__compare--hidden');
          }
        }

        if (offBadge) {
          if (variant.discount_pct > 0) {
            offBadge.textContent = variant.discount_pct + '% OFF';
            offBadge.classList.remove('rabitat-product-card__badge--hidden');
          } else {
            offBadge.textContent = '';
            offBadge.classList.add('rabitat-product-card__badge--hidden');
          }
        }

        if (cartLink) {
          if (isSignupCard) {
            cartLink.setAttribute('data-current-variant-id', String(variant.id));
            cartLink.textContent = signupLabel;
            cartLink.removeAttribute('aria-disabled');
            cartLink.removeAttribute('tabindex');
            cartLink.style.pointerEvents = '';
          } else if (!cartLink.hasAttribute('data-quick-add-trigger')) {
            if (variant.url) {
              cartLink.href = variant.url;
            }

            if (variant.available) {
              cartLink.textContent = cartLabel;
              cartLink.removeAttribute('aria-disabled');
              cartLink.removeAttribute('tabindex');
              cartLink.style.pointerEvents = '';
            } else {
              cartLink.textContent = soldOutLabel;
              cartLink.setAttribute('aria-disabled', 'true');
              cartLink.setAttribute('tabindex', '-1');
              cartLink.style.pointerEvents = 'none';
            }
          } else {
            cartLink.setAttribute('data-current-variant-id', String(variant.id));

            if (variant.available) {
              cartLink.textContent = cartLabel;
              cartLink.removeAttribute('aria-disabled');
              cartLink.removeAttribute('tabindex');
              cartLink.style.pointerEvents = '';
            } else {
              cartLink.textContent = soldOutLabel;
              cartLink.setAttribute('aria-disabled', 'true');
              cartLink.setAttribute('tabindex', '-1');
              cartLink.style.pointerEvents = 'none';
            }
          }
        }

        if (coverLink && variant.url) {
          coverLink.href = variant.url;
        }
      };

      var show = function (index) {
        current = (index + variants.length) % variants.length;
        render(current);
      };

      var bindVariantSwipe = function () {
        if (variants.length <= 1) return;

        var figure = card.querySelector('.rabitat-product-card__figure');
        if (!figure) return;

        var startX = 0;
        var startY = 0;
        var tracking = false;
        var suppressClick = false;
        var SWIPE_THRESHOLD = 40;

        figure.addEventListener('touchstart', function (event) {
          if (!event.touches || !event.touches.length) return;
          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;
          tracking = true;
        }, { passive: true, capture: true });

        figure.addEventListener('touchmove', function (event) {
          if (!tracking || !event.touches || !event.touches.length) return;

          var deltaX = event.touches[0].clientX - startX;
          var deltaY = event.touches[0].clientY - startY;

          if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 12) {
            event.stopPropagation();
          }
        }, { passive: true, capture: true });

        figure.addEventListener('touchend', function (event) {
          if (!tracking) return;
          tracking = false;

          var touch = event.changedTouches && event.changedTouches[0];
          if (!touch) return;

          var deltaX = touch.clientX - startX;
          var deltaY = touch.clientY - startY;

          if (Math.abs(deltaX) < SWIPE_THRESHOLD || Math.abs(deltaX) < Math.abs(deltaY)) {
            return;
          }

          event.preventDefault();
          event.stopPropagation();
          suppressClick = true;
          window.setTimeout(function () {
            suppressClick = false;
          }, 350);

          if (deltaX < 0) {
            show(current + 1);
          } else {
            show(current - 1);
          }
        }, { passive: false, capture: true });

        if (coverLink) {
          coverLink.addEventListener('click', function (event) {
            if (suppressClick) {
              event.preventDefault();
              event.stopPropagation();
            }
          }, true);
        }
      };

      render(0);

      if (!card.closest('.rabitat-collection')) {
        bindVariantSwipe();
      } else {
        bindCollectionCardNavigation(card);
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          show(current - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          show(current + 1);
        });
      }

      if (cartLink) {
        cartLink.addEventListener('click', function (event) {
          if (cartLink.getAttribute('aria-disabled') === 'true') {
            event.preventDefault();
            return;
          }

          var signupSection = cartLink.closest('[data-signup-collection]');
          var isSignupTrigger = cartLink.hasAttribute('data-signup-trigger') || !!signupSection;

          if (isSignupTrigger) {
            event.preventDefault();
            event.stopPropagation();

            var signupCard = cartLink.closest('[data-product-card]');
            var variantId = cartLink.getAttribute('data-current-variant-id') || signupCard.getAttribute('data-initial-variant-id');
            var selectedVariant = variants.find(function (v) {
              return String(v.id) === String(variantId);
            }) || variants[current];

            document.dispatchEvent(new CustomEvent('rabitat:signup:open', {
              detail: {
                productId: signupCard ? signupCard.getAttribute('data-product-id') : '',
                productTitle: signupCard ? signupCard.getAttribute('data-product-title') : '',
                productHandle: signupCard ? signupCard.getAttribute('data-product-handle') : '',
                variant: selectedVariant,
                sectionRoot: signupSection
              }
            }));
            return;
          }

          if (cartLink.hasAttribute('data-quick-add-trigger')) {
            event.preventDefault();
            event.stopPropagation();

            var quickAddCard = cartLink.closest('[data-product-card]');
            var quickAddJson = quickAddCard ? quickAddCard.querySelector('[data-product-quick-add]') : null;

            if (quickAddJson) {
              try {
                var quickAddData = JSON.parse(quickAddJson.textContent);
                var quickAddVariantId = cartLink.getAttribute('data-current-variant-id') || quickAddCard.getAttribute('data-initial-variant-id');

                document.dispatchEvent(new CustomEvent('rabitat:quick-add:open', {
                  detail: {
                    data: quickAddData,
                    variantId: quickAddVariantId
                  }
                }));
              } catch (error) {
                console.error('Quick add data parse error:', error);
              }
            }
          }
        });
      }
    });
  }

  function initCollectionCarousel() {
    document.querySelectorAll('[data-collection-carousel]').forEach(function (carousel) {
      var viewport = carousel.querySelector('[data-collection-viewport]');
      var track = carousel.querySelector('[data-collection-track]');
      var prevBtn = carousel.querySelector('[data-collection-prev]');
      var nextBtn = carousel.querySelector('[data-collection-next]');
      if (!viewport || !track) return;

      viewport.classList.remove('is-rabitat-draggable', 'is-rabitat-swipeable');
      viewport.dataset.rabitatDragScroll = 'off';
      viewport.dataset.rabitatDragScrollBound = 'true';

      var scrollByCard = function (direction) {
        var cardSelector = carousel.getAttribute('data-carousel-item') || '.rabitat-product-card';
        var card = track.querySelector(cardSelector);
        if (!card) return;
        var gap = parseFloat(getComputedStyle(track).gap || 0) || 0;
        viewport.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: 'smooth' });
      };

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          scrollByCard(-1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          scrollByCard(1);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initProductCards();
      initCollectionCarousel();
    });
  } else {
    initProductCards();
    initCollectionCarousel();
  }

  document.addEventListener('shopify:section:load', function () {
    initProductCards();
    initCollectionCarousel();
  });
})();
